import { render, staticRenderFns } from "./OrderParticularsComponent.vue?vue&type=template&id=7088f130&scoped=true&"
import script from "./OrderParticularsComponent.vue?vue&type=script&lang=js&"
export * from "./OrderParticularsComponent.vue?vue&type=script&lang=js&"
import style0 from "./OrderParticularsComponent.vue?vue&type=style&index=0&id=7088f130&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7088f130",
  null
  
)

export default component.exports